// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-up.js';

import { paths } from '../generated/arrow-up';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-up', Original, paths);
